(function () {
    "use strict";

    // @ngInject
    function NewInviteNetworkUserControllerCtor($scope, $modalInstance, $injector, $q, $translate, ContactsManager, UsersManager, UserService, _, CompanyService, ModelFactory, NetworkManager, GoogleAPIService, AnalyticsService, PopupMessageService, SearchablesManager, ValidationsManager) {

        this.constructor.$super.call(this, $scope, $modalInstance, $injector, $translate, UsersManager, UserService, _, CompanyService, ModelFactory, NetworkManager, GoogleAPIService, AnalyticsService, SearchablesManager, ValidationsManager);
        this.__objectType = 'NewInviteNetworkUserController';

        this.ContactsManager = ContactsManager;
        this.NetworkManager = NetworkManager;
        this.PopupMessageService = PopupMessageService;
        this.$q = $q;

        this.titleText = $translate.instant("ADD_USER_DIALOG.INVITE_CONNECTION_MODAL._TITLE_");
        this.subTitleText = $translate.instant("ADD_USER_DIALOG.INVITE_CONNECTION_MODAL._SUBTITLE_");
        this.ctaText = $translate.instant("ADD_USER_DIALOG.INVITE_CONNECTION_MODAL._INVITE_");
        this.isVendor = true;
        this.isVendorEditDisabled = true;
        this.showOptionalFields = false;
        this.user.system_user_type = 'vendor';

        this.isSuggestFromGmailContacts = true;
        this.isSuggestFromDirectory = false; // for now we disable, need to handle this with new ux, no email.

    }

    Controllers.NewInviteNetworkUserController = Class(Controllers.NewAddUserController, {

        constructor: NewInviteNetworkUserControllerCtor,

        saveUser: function saveUser() {
            var defer = this.$q.defer();
            var user = this.user;

            //todo: handle the company type other if no match. need to update user.company.company_other. and company_type should be other.

            this.NetworkManager.inviteUserAsNetworkConnection(user)
                .then(function saveContactSuccess(resp) {
                    defer.resolve(resp.data);
                }.bind(this))
                .catch(function saveContactError(resp) {
                    defer.reject(resp);
                }.bind(this));
            return defer.promise;
        },

        handleUserFromDb: function handleUserFromDb(dbUser){
            if (dbUser.email){
                if (!dbUser.isVendor()) {
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'NETWORK.INVITE_USER._CANNOT_ADD_CLIENT_USER_', function () {});
                    this.user.email = null;
                    return;

                }
                this.user = dbUser;
                this.afterIsVendorChanged();
            }
            else{ //user doesn't exist
                this.user._id = null; // user doesn't exist yet (it will also remove the avatar).
            }
        },


        shouldShowWillInviteFooter: function () {
            return true;
        }
    });
}());